import { render, staticRenderFns } from "./ModalKonfirmasiNonaktifkan.vue?vue&type=template&id=619202f8&"
import script from "./ModalKonfirmasiNonaktifkan.vue?vue&type=script&lang=js&"
export * from "./ModalKonfirmasiNonaktifkan.vue?vue&type=script&lang=js&"
import style0 from "./ModalKonfirmasiNonaktifkan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports